import { DashboardSeverity } from '../../../DashboardBirdview'
import {
  OVERVIEW_ATTENTION_SEVERITY,
  OVERVIEW_ATTENTION_TYPE,
} from '../RentalPortalOverview.constants'

export const QA_NAME_OVERVIEW_ATTENTION_REASON =
  'rentalPortalOverviewAttentionReason'

export const QA_NAME_OVERVIEW_ATTENTION_VIEW =
  'rentalPortalOverviewAttentionView'

export const OVERVIEW_ATTENTION_TONE_BY_SEVERITY = {
  [OVERVIEW_ATTENTION_SEVERITY.amber]: DashboardSeverity.Warning,
  [OVERVIEW_ATTENTION_SEVERITY.red]: DashboardSeverity.Error,
}

export const OVERVIEW_ATTENTION_REASON_VALUE_FIELD_BY_TYPE = {
  [OVERVIEW_ATTENTION_TYPE.newApplicants]: 'count',
  [OVERVIEW_ATTENTION_TYPE.stale]: 'days',
}

// TODO: equals LISTING_PUBLISHINGS_TAB_SEGMENT / LISTING_PROFILE_TAB_PUBLISHINGS
// — drop it for `getListingPublishingsTabUrl` once the listing-profile barrel
// re-exports that builder.
export const OVERVIEW_ATTENTION_PUBLISHINGS_TAB_SEGMENT = 'publishings'
